<script setup lang="ts">
import {
  SHARE_WHATSAPP_URL,
  SHARE_TELEGRAM_URL,
  SHARE_VK_URL,
} from '@/shared/constants/urlConstants';

import type {
  ILawyerCardShareListProps,
  ILawyerCardShareListEmits,
} from '@/widgets/LawyerCard/model/types/lawyerCardContext';

import { ROOT_URL_HOST } from '@/shared/constants/contactConstants';

interface IShareItem {
  id: number;
  url: string;
  icon: string;
  label: string;
}

withDefaults(defineProps<ILawyerCardShareListProps>(), {
  isArticle: false,
});

const emit = defineEmits<ILawyerCardShareListEmits>();

const route = useRoute();
const currentRoute: ComputedRef<string> = computed(
  () => `${ROOT_URL_HOST}${route.fullPath}`,
);

const shareItems: ComputedRef<IShareItem[]> = computed(() => [
  {
    id: 1,
    url: `${SHARE_WHATSAPP_URL}${currentRoute.value}`,
    icon: 'Whatsapp',
    label: 'whatsapp',
  },
  {
    id: 2,
    url: `${SHARE_TELEGRAM_URL}${currentRoute.value}`,
    icon: 'Telegram',
    label: 'telegram',
  },
  {
    id: 3,
    url: `${SHARE_VK_URL}${currentRoute.value}`,
    icon: 'Vk',
    label: 'вконтакте',
  },
]);

const copyHandler = (): void => {
  emit('copy');
};

const closeMenu = (): void => {
  emit('close');
};
</script>

<template>
  <div :class="['context-share-list', { _article: isArticle }]">
    <div v-if="isArticle" class="context-share-list__header">
      <div class="context-share-list__title">Поделиться:</div>
      <button
        class="context-share-list__button _cross"
        aria-label="Закрыть меню"
        @click.prevent="closeMenu"
      >
        <AppIcon name="Cross" />
      </button>
    </div>
    <ul class="context-share-list__list">
      <li v-for="item in shareItems" :key="item.id" class="context-share-list__item">
        <a
          class="context-share-list__button"
          :href="item.url"
          target="_blank"
          rel="noopener noreferrer"
        >
          <AppIcon class="context-share-list__icon" :name="item.icon" />
          <span class="context-share-list__button-text">{{ item.label }}</span>
        </a>
      </li>
      <li class="context-share-list__item">
        <button
          class="context-share-list__button"
          aria-label="Скопировать ссылку"
          @click.prevent="copyHandler"
        >
          <AppIcon class="context-share-list__icon" name="Chain" />
          <span class="context-share-list__button-text">скопировать ссылку</span>
        </button>
      </li>
    </ul>
  </div>
</template>

<style lang="less">
.context-share-list {
  .flex-column(@size-x3);

  min-width: 195px;

  &__title {
    font-size: @size-x4;
    line-height: 21px;
    font-weight: 600;
  }

  &__item {
    &:not(:last-child) {
      margin-bottom: @size-x3;
    }
  }

  &__button {
    display: inline-flex;
    align-items: center;
    font-size: 14px;
    line-height: 19px;
    font-weight: 500;
    width: 100%;

    &._cross {
      position: absolute;
      z-index: 2;
      width: @size-x5;
      height: @size-x5;
      top: @size-x3;
      right: @size-x3;
    }
  }

  &__button-text {
    margin-left: 5px;
  }

  &__icon {
    width: 15px;
    height: 15px;
  }

  &._article {
    .box-shadow();

    background: white;
    padding: @size-x4;
  }
}
</style>
